<style src="./OccupationRate.scss" lang="scss"></style>
<template>
  <section class="occupation-rate wrapper wrapper-content animated fadeInRight">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="generateReport">
        <div class="formContainer">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Estacionamento</label>
              <div class="col-sm-12">
                <select
                  class="form-control"
                  v-model="form.parking">
                  <option
                    v-for="(parking, parkingIdx) in parksList"
                    :key="parkingIdx"
                    :value="parking._id">{{ parking.parkName }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data</label>
              <div class="col-sm-12">
                <input type="date" v-model="reportDate">
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Inicial</label>
              <div class="col-sm-12">
                <input type="time" v-model="startTime">
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Final</label>
              <div class="col-sm-12">
                <input type="time" v-model="endTime">
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Gerar Relatório
            </button>
          </div>
        </div>
      </form>
    </div>

    <template v-if="reportDetails.totalPeriod">
      <section class="row result animated fadeInRight">
        <div class="col-lg-3">
          <div class="widget navy-bg p-lg text-center">
            <div class="m-b-md">
              <svg
                class="icon"
                viewBox="0 0 576 512">
                <path
                  d="M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z">
                </path>
              </svg>
            </div>
            <h1 class="no-margin">{{ DecimalBR(reportDetails.spots) }}</h1>
            <h4>Total de Vagas</h4>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget blue-bg">
            <div class="row">
              <div class="col-lg-6 text-center">
                <div class="m-b-md">
                  <i class="fa fa-arrow-right fa-4x"></i>
                </div>
                <h1 class="no-margin">{{ DecimalBR(reportDetails.enteredCount) }}</h1>
                <h4>Veículos Entrando</h4>
              </div>
              <div class="col-lg-6 text-center">
                <div class="m-b-md">
                  <i class="fa fa-arrow-left fa-4x"></i>
                </div>
                <h1 class="no-margin">{{ DecimalBR(reportDetails.exitedCount) }}</h1>
                <h4>Veículos Saíndo</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget navy-bg p-lg text-center">
            <div class="m-b-md">
              <svg class="icon" viewBox="0 0 512 512">
                <path
                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z">
                </path>
              </svg>
            </div>
            <h1 class="no-margin">{{ timeConvert(reportDetails.totalPeriod) }}</h1>
            <h4>Tempo total disponibilizado</h4>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget red-bg p-lg text-center">
            <div class="m-b-md">
              <svg 
                class="icon"
                viewBox="0 0 512 512">
                <path
                  d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z">
                </path>
              </svg>
            </div>
            <h1 class="no-margin">{{ timeConvert(reportDetails.totalUsedMinutes) }}</h1>
            <h3>Tempo total de uso</h3>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget yellow-bg">
            <div class="row">
              <h4>Percentual de Uso</h4>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <span class="percentual">{{ DecimalBR(reportDetails.usedPercentual) }}%</span>
              </div>
              <div class="col-lg-6 chart">
                <doughnut-occupation
                  :used-percentual="reportDetails.usedPercentual" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </section>
</template>

<script>
import moment from 'moment';
import DoughnutOccupation from './components/doughnut-occupation/DoughnutOccupation.vue';

export default {
  name: 'OccupationRate',
  components: {
    DoughnutOccupation
  },
  data: () => ({
    showSpinner: false,
    parksList: [],
    reportDate: '',
    startTime: '07:00:00',
    endTime: '08:00:00',
    form: {
      parking: null,
    },
    reportDetails: {}
  }),
  computed: {
    startDate () {
      const dt = `${this.reportDate} ${this.startTime}`
      const m = moment(dt).toDate()
      return m
    },
    endDate () {
      const dt = `${this.reportDate} ${this.endTime}`
      const m = moment(dt).toDate()
      return m
    }
  },
  mounted() {
    this.reportDate = moment().format('YYYY-MM-DD')
    this.ListParks();
  },
  methods: {
    totalToCurrencyBR(value) {
      if (!value) {
        return '0,00';
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    DecimalBR(value) {
      if (!value) {
        return '0';
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },
    timeConvert (n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours).toString().padStart(2, '0');
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes).toString().padStart(2, '0');
      return `${rhours}:${rminutes}`;
    },
    async ListParks() {
      const parksList = await this.$store.dispatch('PARKING/GetParkList');
      this.parksList = parksList;
    },
    async generateReport () {
      const query = {
        parkingId: this.form.parking,
        startDate: this.startDate,
        endDate: this.endDate
      }

      const reportResult = await this.$store.dispatch(
        'REPORTS/OccupationRate',
        { query }
      );
      this.reportDetails = reportResult && reportResult.data && reportResult.data[0] || {}
    }
  }
}
</script>